import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from "react-router-dom";
import { getEventsinner } from "../Service/Api";
import Header from "../Component/Header";
import LazyLoad from 'react-lazyload';

const SchoolEvents = () => {
  useEffect(() => {
    document.title = 'School Events - The Air Force School Subroto Park ';
  }, []);

  const navigate = useNavigate();
  const [filterData, setFilteredData] = useState([]);
  const [openModel, setOpenmodal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [data, setData] = useState([]);
  const [selectedYear, setSelectedYear] = useState();
  const [selectedMonth, setSelectedMonth] = useState("All");
  const [monthOptions, setMonthOptions] = useState(["All"]);
  const [yearRanges, setYearRanges] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [archivedData, setArchivedData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [events, setEvents] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [limit] = useState(10);

  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  // Fetch paginated data from API
 const fetchData = async (page = 1, year = null, buildYears = false) => {
  setLoading(true);
  try {
    const response = await getEventsinner({
      page,
      limit,  year: year || ""
    });

    const responseData = response?.data || [];

    setEvents(responseData);
    setData(responseData);
    setTotalPages(response.totalPages || 1);
    setCurrentPage(response.currentPage || page);
    setTotalCount(response.totalCount || responseData.length);

    // ✅ Only build year ranges when buildYears = true
    if (buildYears) {
      const yearsSet = new Set();
      responseData.forEach(item => {
        if (item.date) yearsSet.add(new Date(item.date).getFullYear());
      }); 
      const years = [...yearsSet].sort((a, b) => b - a);
years.push("Archive"); // ✅ always add archive
setYearRanges(years);

      setYearRanges(years);

      if (years.length > 0) {
        setSelectedYear(years[0].toString()); // default to latest year
      }
    }
  } catch (err) {
    console.error("Error fetching data:", err);
    setEvents([]);
    setData([]);
    setTotalPages(1);
    setCurrentPage(1);
    setTotalCount(0);
  } finally {
    setLoading(false);
  }
};
// On first load → fetch all events (only for year list)
useEffect(() => {
  fetchData(1, null, true);
}, []);

// On year change → fetch events of that year
// useEffect(() => {
//   if (selectedYear && selectedYear !== "Archive") {
//     setCurrentPage(1);
//     fetchData(1, selectedYear);
//   }
// }, [selectedYear]);
useEffect(() => {
  if (selectedYear) {
    setCurrentPage(1);
    fetchData(1, selectedYear); // send "Archive" if selected
  }
}, [selectedYear]);


// On page change → fetch same year’s data
useEffect(() => {
  if (selectedYear && selectedYear !== "Archive") {
    fetchData(currentPage, selectedYear);
  }
}, [currentPage]);


  // Year change handler - reset pagination
  // const handleYearChange = (e) => {
  //   const newYear = e.target.value;
  //   setSelectedYear(newYear);
  //   setCurrentPage(1);
  //   // Fetch data immediately with new year
  //   if (newYear !== "Archive") {
  //     fetchData(1, newYear);
  //   }
  // };

  // Filter logic - this should work on the current page data only for pagination
  useEffect(() => {
    let filteredData = data;

    // Separate archived and valid data
    const archived = filteredData.filter(item => !item.date);
    const validData = filteredData.filter(item => item.date);

    if (selectedYear === "All" && selectedMonth === "All" && searchQuery === "") {
      filteredData = [...validData];
    }

    // If "Archive" is selected, show only archived data
    if (selectedYear === "Archive") {
      setFilteredData([]);
      setArchivedData(archived);
      return;
    }

    // Apply month filtering
    if (selectedMonth !== "All") {
      filteredData = validData.filter(item => {
        const itemDate = item.date?.trim();
        if (itemDate) {
          const itemMonth = new Date(itemDate).getMonth();
          return monthNames[itemMonth] === selectedMonth;
        }
        return false;
      });
    } else {
      filteredData = validData;
    }

    // Search filtering
    if (searchQuery) {
      filteredData = filteredData.filter(item => {
        return item.title && item.title.toLowerCase().includes(searchQuery.toLowerCase());
      });
    }

    // Sort by date descending (latest first)
    filteredData.sort((a, b) => new Date(b.date) - new Date(a.date));

    setFilteredData(filteredData);
    setArchivedData(archived);
  }, [selectedMonth, searchQuery, data]);

  // Pagination handlers - simplified
  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prev => prev + 1);
    }
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(prev => prev - 1);
    }
  };

  // Year change handler - reset pagination
  const handleYearChange = (e) => {
    const newYear = e.target.value;
    setSelectedYear(newYear);
    setCurrentPage(1); // Reset to first page when year changes
  };

  // Month change handler
  const handleMonthChange = (e) => {
    setSelectedMonth(e.target.value);
  };

  const handleModal = id => {
    navigate(`/SubGallery?id=${id}`);
  };

  const modalPopup = (item) => {
    setSelectedItem(item);
    setOpenmodal(true);
  };

  const handleClose = () => {
    setOpenmodal(false);
    setSelectedItem(null);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };

  return (
    <>
      <Header/>
      <div className="innerslide">
        <ul className="breadcrumb">
          <li><Link to="/"> Home</Link></li>
          <li>School Events</li>
        </ul>
      </div>

      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>School Events</h1>
            </div>
          </div>

          <div className="row tabs-dynamic">
            <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
              <div className="count-val">
                <p>Total Categories: {selectedYear === "Archive" ? archivedData.length : filterData.length}</p>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
              <div className="month-selection">
                <select
                  value={selectedYear || ""}
                  onChange={handleYearChange}
                  className="yearSelection"
                >
                  <option key="2025" value="2025">2025</option>
                  <option key="2024" value="2024">2024</option>
                  <option key="2023" value="2023">2023</option>
                  <option key="2022" value="2022">2022</option>
                  <option key="2021" value="2021">2021</option>
                  <option key="2020" value="2020">2020</option>
                  <option key="2019" value="2019">2019</option>
                  <option key="2018" value="2018">2018</option>
                  <option key="2017" value="2017">2017</option>
                  <option key="2016" value="2016">2016</option>
                  {/* {yearRanges.map((yr) => (
                    <option key={yr} value={yr}>{yr}</option>
                  ))} */}
                 <option value="Archive">Archive</option>
                </select>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
              <div className="month-selection">
                <select
                  value={selectedMonth}
                  onChange={handleMonthChange}
                  className="monthSelect"
                >
                  {monthOptions.map((month, index) => (
                    <option key={index} value={month}>{month}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
              <div className="searchBox">
                <input
                  type="text"
                  id="myInput"
                  name="name"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Search Here.."
                />
              </div>
            </div>
          </div>

          {loading ? (
            <div>
              <img src="https://webapi.entab.info/api/image/TAFS/public/Images/loading.gif" className="img-fluid loadingimg"/>
            </div>
          ) : (
            selectedYear === "Archive" && archivedData.length > 0 ? (
              <div className="row years year2024 showYear">
                {archivedData.map((item, index) => (
                  <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 eventCount" key={index}>
                    <div className="eventsnewsbox">
                      <div className="newsboximg">
                        {item.images.length > 0 ? (
                          <LazyLoad>
                            <img src={`https://webapi.entab.info/api/image/${item.images[0]}`} className="img-fluid" alt="TAFS" />
                          </LazyLoad>
                        ) : (
                          <LazyLoad>
                            <img src="https://webapi.entab.info/api/image/TAFS/public/Images/events.jpg" className="img-fluid" alt="TAFS" />
                          </LazyLoad>
                        )}
                      </div>
                      <div className="newsboxdesc">
                        <div className="newspgh">
                          <h5>{item.title}</h5>
                          <p>{item.description}</p>
                          <button onClick={() => modalPopup(item)} className="readmorebtn">Read More</button>
                        </div>
                        <div className="newsdate">
                          <span><i className="bi bi-calendar"></i> {formatDate(item.date)}</span>
                          <span><i className="bi bi-alarm"></i> {item.time}</span>
                          {item.attachments && item.attachments[0] && (
                            <a href={`https://webapi.entab.info/api/image/${item.attachments[0]}`} target="_blank" rel="noopener noreferrer">
                              <i className="bi bi-paperclip"></i>
                            </a>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              selectedYear !== "Archive" && filterData.length > 0 && (
                <div className="row years year2024 showYear">
                  {filterData.map((item, index) => {
                    const date = new Date(item.date);
                    const day = date.getDate();
                    const month = monthNames[date.getMonth()];
                    return (
                      <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 eventCount" key={index}>
                        <div className="eventsnewsbox">
                          <div className="newsboximg">
                            {item.images.length > 0 ? (
                              <LazyLoad>
                                <img src={`https://webapi.entab.info/api/image/${item.images[0]}`} className="img-fluid" alt="TAFS" />
                              </LazyLoad>
                            ) : (
                              <LazyLoad>
                                <img src="https://webapi.entab.info/api/image/TAFS/public/Images/events.jpg" className="img-fluid" alt="TAFS" />
                              </LazyLoad>
                            )}
                          </div>
                          <div className="newsboxdesc">
                            <div className="newspgh">
                              <h5>{item.title}</h5>
                              <p className="Schoolevent">
                                <div dangerouslySetInnerHTML={{ __html: item.description }} />
                              </p>
                              <button onClick={() => modalPopup(item)} className="readmorebtn">Read More</button>
                            </div>
                            <div className="newsdate">
                              <span><i className="bi bi-calendar"></i> {formatDate(item.date)}</span>
                              <span><i className="bi bi-alarm"></i> {item.time}</span>
                              {item.attachments && item.attachments[0] && (
                                <a href={`https://webapi.entab.info/api/image/${item.attachments[0]}`} target="_blank" rel="noopener noreferrer">
                                  <i className="bi bi-paperclip"></i>
                                </a>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )
            )
          )}

          <div className="pagination">
            <button
              disabled={currentPage === 1}
              onClick={handlePrev}
            >
              Prev
            </button>
            <span> Page {currentPage} of {totalPages} (Total: {totalCount}) </span>
            <button
              disabled={currentPage >= totalPages || totalPages === 0}
              onClick={handleNext}
            >
              Next
            </button>
          </div>
        </div>
      </div>

      {openModel && selectedItem && (
        <div className="eventPopup">
          <div className="eventpopupbody">
            <div className="eventpopupcontent">
              <button onClick={handleClose} className="closebtn">X</button>
              <div className="schooleventbox">
                <div className="schooleventrightbox">
                  <h5><div dangerouslySetInnerHTML={{ __html: selectedItem.title }} /></h5>
                  <p><div dangerouslySetInnerHTML={{ __html: selectedItem.description }} /></p>
                  {selectedItem.attachments && selectedItem.attachments[0] && (
                    <div className="attachment popupattch">
                      <Link to={`https://webapi.entab.info/api/image/${selectedItem?.attachments}`} target="_blank"> Click Here To View</Link>
                    </div>
                  )}
                </div>
                {selectedItem.images && selectedItem.images.length > 0 && selectedItem.images.length === 1 ? (
                  selectedItem.images.map((image, index) => (
                    <div key={index} className="schooleventleftbox galleryCount sub-gallerycount">
                      <LazyLoad>
                        <a
                          data-magnify="gallery"
                          data-src={`https://webapi.entab.info/api/image/${image}`}
                          data-group="a"
                          href={`https://webapi.entab.info/api/image/${image}`}
                        >
                          <img
                            src={`https://webapi.entab.info/api/image/${image}`}
                            className="img-fluid float-start"
                            alt={`Image ${index + 1} of The Air Force School Subroto Park`}
                          />
                        </a>
                      </LazyLoad>
                    </div>
                  ))
                ) : null}
                {selectedItem.images && selectedItem.images.length > 0 && selectedItem.images.length > 1 ? (
                  selectedItem.images.map((image, index) => (
                    <div key={index} className="schooleventleftbox galleryCount sub-gallerycount multi-img">
                      <LazyLoad>
                        <a
                          data-magnify="gallery"
                          data-src={`https://webapi.entab.info/api/image/${image}`}
                          data-group="a"
                          href={`https://webapi.entab.info/api/image/${image}`}
                        >
                          <img
                            src={`https://webapi.entab.info/api/image/${image}`}
                            className="img-fluid"
                            alt={`Image ${index + 1} of The Air Force School Subroto Park`}
                          />
                        </a>
                      </LazyLoad>
                    </div>
                  ))
                ) : null}
              </div>

              <div className="row">
                {selectedItem.galleryAttachments?.length > 0 && (
                  selectedItem.galleryAttachments.map((item, index) => (
                    <div
                      key={index}
                      className="col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3 galleryCount sub-gallerycount"
                    >
                      <LazyLoad>
                        <a data-magnify="gallery" data-src="" data-group="a" href={`https://webapi.entab.info/api/image/${item}`}>
                          <img src={`https://webapi.entab.info/api/image/${item}`} className="img-fluid" alt="The Air Force School Subroto Park" />
                        </a>
                      </LazyLoad>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default SchoolEvents